import { render, staticRenderFns } from "./PdfDocView.vue?vue&type=template&id=2cdf9860&"
import script from "./PdfDocView.vue?vue&type=script&lang=js&"
export * from "./PdfDocView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports